<div class="mct-flex mct-col mct-gap-27">
  <div class="mct-flex mct-col atlas-autocomplete" *ngIf="eCommerceItem">
    <label> {{ 'ecommerce.item.affiliation-codes.teaser-message' | translate | ucfirst }} </label>
    <p-autocomplete
      #autoComplete
      [(ngModel)]="selectedAffCodes"
      [disabled]="isReadOnly"
      [multiple]="true"
      [dropdown]="true"
      [suggestions]="affCodeSearchResults"
      (completeMethod)="searchAffCodes($event)"
      (onSelect)="addAffCode($event.value)"
      (onUnselect)="deleteAffCode($event.value)"
      appendTo="body"
    >
    </p-autocomplete>
  </div>
</div>
